import React from 'react';
const ShotListSelectHeader = ({ headerClicked, show = true }) => {

  const checkStyle = {
    width: '25px',
    height: '25px',
    transform: 'translate(-7px, 2px)'
  };

  return (
    <div>
      <div>
        {
        show &&(<input type="checkbox" style={checkStyle} onChange={headerClicked}/>)
        }
      </div>
    </div>
  );
};

export default ShotListSelectHeader;